import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Carousel } from "react-bootstrap";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Accordion,
  Breadcrumb,
  Form,
} from "react-bootstrap";
import { FaCoins, FaTag, FaShoppingBag, FaShoppingCart } from "react-icons/fa";
import "./Nios.css";
import { FaLightbulb, FaCogs, FaChartBar } from "react-icons/fa";
import { FaRegLightbulb, FaRocket, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import {
  FaUniversity,
  FaChalkboardTeacher,
  FaLayerGroup,
  FaGlobeAsia,
  FaMoneyBillWave,
  FaUserFriends,
} from "react-icons/fa";
import { FaGraduationCap, FaDollarSign } from "react-icons/fa";
import {
  FaTools,
  FaClipboardCheck,
  FaAward,
  FaBriefcase,
} from "react-icons/fa";
import { FaBook, FaUserGraduate } from "react-icons/fa";

import {
  FaSnowflake,
  FaUser,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  FaClock, // Flexible Learning Schedule
  FaCertificate, // Government-Recognized Certification (use FaCertificate or FaIdBadge)
  FaBookOpen, // Wide Subject Choices
  FaLaptop, // Easy Online Process
} from "react-icons/fa";

import { FaStopwatch, FaCog } from "react-icons/fa";
import Admission from "../components/Admission";
import Partner from "../components/Partner";
import { Link } from "react-router-dom";

export default function Bosse() {
  const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true, // optional
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
  ],
};


  const images = [
    "/images/slide1.jpeg",
    "/images/slide2.jpeg",
    "/images/slide3.jpeg",
    "/images/slide4.jpeg",
    "/images/slide5.jpeg",
    "/images/slide6.jpeg",
    "/images/slide7.jpeg",
    "/images/slide8.png",
    "/images/slide9.png",
  ];

  const chunked = [];
  for (let i = 0; i < images.length; i += 3) {
    chunked.push(images.slice(i, i + 3));
  }

  const banners = [
    "/images/ban1.jpeg",
    "/images/ban2.jpeg",
    "/images/ban3.jpeg",
    "/images/ban4.jpeg",
  ];
  const faqData = [
    {
      question: "What is BOSSE?",
      answer:
        "BOSSE (Board of Open Schooling and Skill Education) is an educational board offering flexible learning opportunities, open schooling, and skill-based education programs for students across India.",
    },

    {
      question: "Why Choose BOSSE?",
      answer:
        "BOSSE stands out as a leading Open Schooling Board in India due to its flexible subject choices, convenient examination options, and engaging curriculum available in Hindi, English, and various regional languages. It offers Transfer of Credits for up to four subjects, high-quality academic and career-oriented programmes, and accessible education at an affordable fee, making it an excellent choice for learners across the country.",
    },
    {
      question: "How to Take Admission in BOSSE?",
      answer:
        "The admission process at BOSSE is simple, seamless, and secure. Interested candidates can apply by filling out the registration form, submitting the required documents, and paying the applicable fee. Once these steps are completed, admission to BOSSE is successfully processed.",
    },
    {
      question: "Who can enroll in BOSSE courses?",
      answer:
        "Anyone aiming to enhance their qualifications at the Secondary or Senior Secondary level can take admission in BOSSE. The Open and Distance Learning (ODL) system is designed to support a diverse group of learners, including school dropouts, students who could not clear board exams, rural youth, working professionals, and individuals from economically weaker sections. BOSSE offers both academic and skill-based vocational education to help learners progress in their careers and studies.",
    },
    {
      question: "What types of courses does BOSSE offer?",
      answer:
        "BOSSE offers secondary (Class 10) and senior secondary (Class 12) courses, vocational and skill-based programs, and open schooling options for learners who cannot pursue regular schooling.",
    },
    {
      question: "How can I apply for BOSSE admission?",
      answer:
        "You can apply online through the official BOSSE website by filling out the admission form, submitting the required documents, and paying the applicable fees for your chosen course or program.",
    },
    {
      question: "Does BOSSE conduct examinations?",
      answer:
        "Yes, BOSSE conducts examinations for secondary, senior secondary, and skill-based courses. Exam schedules and admit cards are made available on the official BOSSE website.",
    },
    {
      question: "How can I get my BOSSE results and certificates?",
      answer:
        "BOSSE publishes results online on its official website. After passing the exams, students can download their certificates or request a physical copy from BOSSE as per the guidelines.",
    },
    {
      question: "Is it enlisted in COBSE?",
      answer:
        "Yes, it enlisted in COBSE. The same can be checked at the respec!ve website of cobse i.e.https://www.cobse.org.in/",
    },
    {
      question: "Is the Marksheet Valid All Over India?",
      answer:
        "All our recognitions and approvals, along with positive RTI responses from various government universities, are available on the BOSSE website for reference. However, if you wish to check the acceptance of the marksheet in a specific institution or organization, you are advised to verify directly with that particular institution for confirmation.",
    },
    {
      question: "What is the Procedure for Verification?",
      answer:
        "All requests for verification of marksheets or migration certificates should be sent via email to verification@bosse.ac.in or mailed to the address provided under the Contact Us section. Verification requests are accepted only from Universities, Colleges, Schools, or organizations where the student has been admitted or employed. There is no fee for verification requests from local institutions or entities. For verification charges applicable to foreign institutions or organizations, please refer to the BOSSE prospectus. Additionally, marks cards and results will also be available on the DIGILOCKER digital platform for easy access and authentication.",
    },
    {
      question:
        "What is the Duration for Result Declaration and Award of Certificate?",
      answer:
        "BOSSE announces the results for Secondary and Senior Secondary programmes and dispatches the certificates within 45 to 60 working days after the completion of the examinations.",
    },
    {
      question:
        "What is the Eligibility Criteria for Admission to Secondary and Senior Secondary Programmes at BOSSE?",
      answer: `
Secondary Programme:
Any individual who is 15 years of age or older is eligible for admission, even without prior formal education. Applicants must provide valid age proof and a certification confirming that they can read and understand the study materials and write the examination.

Senior Secondary Programme:
Anyone who has successfully passed Class X is eligible to apply for admission to the Senior Secondary Programme.
`,
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Online Application",
      text: "Apply via the official portal, fill the form, and select your preferred BOSSE course or stream.",
      icon: "🌐",
    },
    {
      num: "2",
      title: "Document Submission",
      text: "Provide mark sheets, ID proof, and photographs for eligibility verification.",
      icon: "📝",
    },
    {
      num: "3",
      title: "Course Selection",
      text: "Choose from BOSSE online courses, academic, or vocational programs based on your career goals.",
      icon: "📚",
    },
    {
      num: "4",
      title: "Fee Payment",
      text: "Securely pay the course fees via online banking or UPI to confirm enrollment.",
      icon: "💳",
    },
    {
      num: "5",
      title: "Access Study Material",
      text: "Receive digital or printed study resources for BOSSE distance education in Bangalore or nationwide.",
      icon: "📖",
    },
    {
      num: "6",
      title: "Assessment & Evaluation",
      text: "Participate in online exams, term-wise assessments, and assignments to complete your program and receive certification.",
      icon: "✅",
    },
  ];

  const opportunities = [
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png",
      title: "Higher Education",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      title: "Government Jobs",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135768.png",
      title: "Vocational Training",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135810.png",
      title: "Entrepreneurship",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135712.png",
      title: "Competitive Exams",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135789.png",
      title: "Private Sector Employment",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135763.png",
      title: "Apprenticeships & Internships",
    },
    {
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135815.png",
      title: "Overseas Education & Jobs",
    },
  ];

  const people = [
    {
      id: 1,
      name: "Priya Menon",

      course: "MBA (Working Professional, Bangalore)",
      img: "/images/stu1.jpg",
      desc: "Flexible & career-boosting",
      color: "#4ECDC4",
      details:
        "Bangalore Distance Education made it possible to earn my MBA while working full-time.The support, materials, and flexibility helped me grow—and even get promoted.",
    },
    {
      id: 2,
      name: "Rohan Sharma",

      course: "M.Com (Homemaker, Kochi)",
      img: "/images/stu2.jpg",
      desc: "Perfect for homemakers",
      color: "#FF6B6B",
      details:
        "After marriage, I thought studying was impossible, but Bangalore Distance Education’s M.Com program made it achievable.",
    },
    {
      id: 3,
      name: "Sneha Reddy",

      course: "BCA (Fresh 12th Pass, Patna)",
      img: "/images/stu3.jpg",
      desc: "Great for beginners",
      color: "#FFD166",
      details:
        "I didn’t leave my hometown; Bangalore Distance Education’s UGC-approved BCA program boosted my IT career.",
    },
    {
      id: 4,
      name: "Amit Kumar",

      course: "BBA (Entrepreneur, Hyderabad)",
      img: "/images/stu4.jpg",
      desc: "Ideal for entrepreneurs",
      color: "#6A4C93",
      details:
        "Running my startup seemed impossible with studies, but Bangalore Distance Education’s BBA course made it practical.",
    },
    {
      id: 5,
      name: "Anita Patel",

      course: "MCA (IT Professional, Pune)",
      img: "/images/stu5.jpg",
      desc: "Boosted my IT career",
      color: "#4ECDC4",
      details:
        "I needed an MCA to advance my career; Bangalore Distance Education offered flexibility, support, and excellence.",
    },
    {
      id: 6,
      name: "Vikram Singh",

      course: "MA English (School Teacher, Ahmedabad)",
      img: "/images/stu6.jpg",
      desc: "Perfect for teachers",
      color: "#FF6B6B",
      details:
        "As a full-time teacher, Bangalore Distance Education’s MA program allowed me to study flexibly and succeed.",
    },
    {
      id: 7,
      name: "Karan Mehta",
      course: "B.Com (Bank Employee, Mumbai)",
      img: "/images/stu7.jpg",
      desc: "Affordable & recognized",
      color: "#FFD166",
      details:
        "Bangalore Distance Education guided me through B.Com; affordable, recognized, and weekend classes helped me succeed.",
    },
    {
      id: 8,
      name: "Rahul Gupta",

      course: "PhD (Research Scholar, Chennai)",
      img: "/images/stu8.jpg",
      desc: "Great guidance for research",
      color: "#6A4C93",
      details:
        "Pursuing a PhD while working was possible thanks to Bangalore Distance Education’s guidance, flexibility, and support.",
    },
    {
      id: 9,
      name: "Divya Nair",

      course: "MBA HR (Team Lead, Delhi)",
      img: "/images/stu9.jpg",
      desc: "Career-focused learning",
      color: "#4ECDC4",
      details:
        "Bangalore Distance Education’s MBA in HR is practical, career-focused, with projects, case studies, and placement support.",
    },
    {
      id: 10,
      name: "Ankit Vishnoi",
      course: "BCA (Freelancer, Bangalore)",
      img: "/images/mca.jfif",
      desc: "Transparent & supportive",
      color: "#FF6B6B",
      details:
        "Bangalore Distance Education stood out with transparency, support, and a BCA program that built my tech career.",
    },
  ];

  const getRandomColor = () => {
    const colors = [
      "#28a745",
      "#007bff",
      "#e83e8c",
      "#6f42c1",
      "#fd7e14",
      "#20c997",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: { slidesToShow: 2 },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: { slidesToShow: 1 },
  //     },
  //   ],
  // };

  const features = [
    {
      icon: <FaClock />,
      title: "Flexible Learning Options",
      details:
        "BOSSE offers distance education, online courses in Bangalore, and open schooling in India, enabling learners to study at their own pace with flexible schedules, ideal for professionals, homemakers, and remote learners.",
    },
    {
      icon: <FaCertificate />,
      title: "Recognized & Credible Board",
      details:
        "The BOSSE board is government-approved and nationally recognized. Certificates from BOSSE open school and skill programs are valid for higher education, competitive exams, and career advancement.",
    },
    {
      icon: <FaBookOpen />,
      title: "Comprehensive Range of Courses",
      details:
        "BOSSE courses include secondary education (Class 10), senior secondary education (Class 12), and vocational programs in IT, healthcare, tourism, retail, and professional services, ensuring wide-ranging academic and career opportunities.",
    },
    {
      icon: <FaLaptop />,
      title: "Nationwide Accessibility",
      details:
        "BOSSE open schooling in India and BOSSE schools in India provide inclusive education accessible to students from urban and rural regions, including BOSSE board in Bangalore, removing geographical barriers.",
    },
    {
      icon: <FaLaptop />,
      title: "Affordable Education",
      details:
        "The BOSSE admission process and course fees are designed to be cost-effective, offering high-quality education and recognized certifications without the high cost of traditional schooling.",
    },
  ];

  const benefitsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Self-Paced Learning",
      description:
        "Study at your own convenience without disrupting work or personal life.",
    },
    {
      icon: <FaTools size={36} className="text-success mb-3" />,
      title: "Skill Development Focus",
      description:
        "Gain practical skills alongside academic knowledge for career growth.",
    },
    {
      icon: <FaClipboardCheck size={36} className="text-warning mb-3" />,
      title: "Flexible Examinations",
      description:
        "Choose term-wise or on-demand assessments aligned to your schedule.",
    },
    {
      icon: <FaLaptop size={36} className="text-info mb-3" />,
      title: "Digital Learning Support",
      description:
        "Access online courses with study materials, recorded lectures, and expert guidance.",
    },
    {
      icon: <FaAward size={36} className="text-danger mb-3" />,
      title: "Nationwide Recognition",
      description:
        "Certificates are recognized by universities, colleges, and employers across India.",
    },
    {
      icon: <FaBriefcase size={36} className="text-secondary mb-3" />,
      title: "Career Advancement",
      description:
        "Vocational courses enhance employability and entrepreneurial skills for job opportunities.",
    },
  ];

  const coursesData = [
    {
      icon: <FaBook size={36} className="text-primary mb-3" />,
      title: "Secondary Education (Class 10)",
      path: "/secondary-programme",
      description: "Foundation for higher education.",
    },
    {
      icon: <FaUserGraduate size={36} className="text-success mb-3" />,
      title: "Senior Secondary Education (Class 12)",
      path: "/senior-secondary",
      description: "Prepares students for university admissions.",
    },
    {
      icon: <FaTools size={36} className="text-warning mb-3" />,
      title: "Vocational & Skill-Based Programs",
      description:
        "Courses in IT, healthcare, tourism, retail, hospitality, and professional services.",
    },
    {
      icon: <FaCertificate size={36} className="text-danger mb-3" />,
      title: "Professional Certification Courses",
      description:
        "Short-term skill enhancement programs for working professionals.",
    },
  ];

  const featuresData = [
    {
      icon: <FaUniversity size={36} className="text-primary mb-3" />,
      title: "COBSE-Approved Board",
      description:
        "Provides nationally recognized academic and skill-based certification.",
    },
    {
      icon: <FaChalkboardTeacher size={36} className="text-success mb-3" />,
      title: "Flexible Learning Mode",
      description:
        "Offers distance, online, and open schooling formats suitable for working professionals.",
    },
    {
      icon: <FaLayerGroup size={36} className="text-warning mb-3" />,
      title: "Wide Course Options",
      description:
        "Academic, vocational, and professional courses tailored to career advancement and higher education.",
    },
    {
      icon: <FaGlobeAsia size={36} className="text-info mb-3" />,
      title: "Accessible Across India",
      description:
        "Available in BOSSE schools in India and BOSSE board in Bangalore for inclusive education.",
    },
    {
      icon: <FaMoneyBillWave size={36} className="text-danger mb-3" />,
      title: "Affordable Education",
      description:
        "Cost-effective courses providing quality education and recognized credentials.",
    },
    {
      icon: <FaBriefcase size={36} className="text-secondary mb-3" />,
      title: "Career-Focused Curriculum",
      description:
        "Blends theoretical knowledge with practical skills for employability and entrepreneurship.",
    },
    {
      icon: <FaUserFriends size={36} className="text-dark mb-3" />,
      title: "Student Support Services",
      description:
        "Academic counseling, mentoring, doubt-solving, and online resources ensure learner success.",
    },
  ];

  return (
    <>
      {/* Hero Section */}

      <Helmet>
        <title>
          BOSSE Admission | Board of Open Schooling & Skill Education
        </title>
        <meta
          name="description"
          content="Join BOSSE open schooling in India. Apply for BOSSE admission, BOSSE online courses, and BOSSE distance education in Bangalore for flexible learning."
        />
      </Helmet>

      <div style={{ backgroundColor: "#F5F5F5" }}>
        <div style={{ backgroundColor: "#F5F5F5" }}>
          <div>
            <Carousel fade interval={2500} pause={false}>
              {banners.map((img, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100"
                    src={img}
                    alt={`Slide ${index}`}
                    style={{
                      height: "600px",
                      objectFit: "contain", // FIXED (no cropping)
                      backgroundColor: "#000", // optional, looks good
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          {/* Intro Section */}
          <section className="nios-admission2025-wrapper">
            <div className="nios-admission2025-container">
              {/* Left Side */}
              <div className="nios-admission2025-left">
                <img
                  src="/images/825079.jpg"
                  alt="Focused student engaged in online learning with laptop and notes for Board of Open Schooling and Skill Education (BOSSE) flexible education"
                  className="nios-admission2025-image"
                />
              </div>

              {/* Right Side */}
              <div className="nios-admission2025-right">
                <h2 className="nios-admission2025-heading">
                  Board of Open Schooling and Skill Education (BOSSE) - Flexible
                  Open Schooling and Skill Education
                </h2>
                <p className="nios-admission2025-text">
                  The Board of Open Schooling and Skill Education (BOSSE) is a
                  leading open schooling and skill development board in India.
                  BOSSE provides flexible, high-quality education for students,
                  working professionals, and lifelong learners. Offering
                  secondary (Class 10), senior secondary (Class 12), vocational
                  courses, and professional certifications, BOSSE emphasizes
                  both academic excellence and practical skill development. With
                  BOSSE online courses, learners can study remotely in Bangalore
                  or anywhere in India, ensuring education is accessible,
                  convenient, and adaptable to individual schedules. BOSSE
                  empowers students with recognized certifications, modern
                  curricula, and skill-based training, opening pathways for
                  higher education, employment, and entrepreneurial
                  opportunities. Whether enrolling in BOSSE distance education
                  in Bangalore, a BOSSE open school, or BOSSE schools in India,
                  learners gain the flexibility to balance personal,
                  professional, and academic commitments while achieving
                  credible qualifications.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Features Section */}
        <div className="banner-container">
          <div className="banner-grid">
            {/* Box 1 */}
            <div className="banner-box blue">
              <div className="banner-icon">
                <FaRegLightbulb />
              </div>
              <h2>Unmatched Flexibility</h2>
              <p>
                Study at your own pace with no fixed schedule—perfect for
                working individuals and self-paced learners.
              </p>
            </div>

            {/* Box 2 */}
            <div className="banner-box yellow">
              <div className="banner-icon">
                <FaRocket />
              </div>
              <h2>Diverse Array of Courses</h2>
              <p>
                Choose from a wide range of academic and vocational subjects
                tailored to suit different interests and career goals.{" "}
              </p>
            </div>

            {/* Box 3 */}
            <div className="banner-box red">
              <div className="banner-icon">
                <FaUsers />
              </div>
              <h2>Inclusive Accessibility</h2>
              <p>
                Open to learners of all ages, backgrounds, and regions—making
                quality education available to everyone.{" "}
              </p>
            </div>
          </div>
        </div>

        <br />
        <br />

        <img
          src="./images/headimg.jpeg"
          alt="BOSSE Banner"
          style={{
            width: "80%", // adjust width as needed
            maxWidth: "600px", // optional, to limit size on large screens
            height: "auto", // maintain aspect ratio
            display: "block",
            margin: "auto", // center horizontally
            borderRadius: "8px", // optional, for rounded corners
          }}
        />
        <br />
        <br />
        <div style={{ width: "100%" }}>
          <Carousel interval={2000} pause={false} indicators={false}>
            {chunked.map((group, index) => (
              <Carousel.Item key={index}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 20px",
                  }}
                >
                  {group.map((img, idx) => (
                    <div
                      key={idx}
                      style={{
                        width: "32%",
                        overflow: "hidden",
                        borderRadius: "10px",
                        backgroundColor: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "250px",
                      }}
                    >
                      <img
                        src={img}
                        alt={`img-${idx}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // 🔥 FIXED — no cropping
                        }}
                      />
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose BOSSE</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your Board of Open Schooling and Skill Education (BOSSE)"
                style={{
                  width: "500px",
                  height: "650px",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                The BOSSE admission process, while simpler than traditional
                schooling systems, can still feel overwhelming for first-time
                applicants. Here’s what students commonly face
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/*  */}

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Benefits of BOSSE Education
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                BOSSE provides students with a modern and flexible education
                model that adapts to individual learning styles, career goals,
                and life commitments.
              </p>
            </div>

            {/* Benefits Grid */}
            <Row className="g-4">
              {benefitsData.map((benefit, index) => (
                <Col md={4} key={index}>
                  <Card className="h-100 shadow border-0">
                    <Card.Body className="text-center">
                      {benefit.icon}
                      <h5 className="fw-bold">{benefit.title}</h5>
                      <p className="text-muted">{benefit.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #fff, #f0f4ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Courses Offered by BOSSE
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                BOSSE offers a diverse range of academic and skill-based courses
                designed to empower learners at every stage of their educational
                and professional journey.
              </p>
            </div>

            {/* Courses Grid */}
            <Row className="g-4">
              {coursesData.map((course, index) => (
                <Col md={6} key={index}>
                  <Link key={course.id} to={course.path}>
                    <Card className="h-100 shadow border-0">
                      <Card.Body className="text-center">
                        {course.icon}
                        <h5 className="fw-bold">{course.title}</h5>
                        <p className="text-muted">{course.description}</p>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Admission Process */}

        <div className="process-wrapper">
          <h1 className="text-center mb-5">Our Admission Process</h1>
          <div className="process-container">
            {steps.map((s) => (
              <div key={s.num} className="process-step">
                <div className="step-icon">{s.icon}</div>

                <div className="step-number">{s.num}</div>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-text">{s.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ----- */}

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Features of BOSSE
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                BOSSE combines flexibility, affordability, and recognition to
                make education accessible for every learner across India.
              </p>
            </div>

            {/* Features Grid */}
            <Row className="g-4 justify-content-center">
              {featuresData.map((feature, index) => (
                <Col
                  md={4}
                  key={index}
                  className={
                    featuresData.length % 3 === 1 &&
                    index === featuresData.length - 1
                      ? "d-flex justify-content-center"
                      : ""
                  }
                >
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {feature.icon}
                      <h5 className="fw-bold">{feature.title}</h5>
                      <p className="text-muted">{feature.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <img
          src="./images/bosse/imp-img.jpeg"
          alt=""
          style={{
            width: "100%",
            maxWidth: "1200px",
            height: "auto",
            display: "block",
            margin: "50px auto",
          }}
        />

        {/* Career Opportunities */}

        {/* Partner Universities */}

        <Partner></Partner>

        {/* Testimonials */}

        <div className="text-center">
          <h1>Testimonial</h1>
        </div>
        <div>
          <Slider {...settings} className="testimonial-slider">
            {people.map((p) => (
              <div key={p.id}>
                <div className="profilecards-box">
                  {/* <h5>{p.desc}</h5> */}
                  <p className="profilecards-desc">"{p.details}"</p>

                  <div className="profilecards-avatar-wrap">
                    <img
                      src={p.img}
                      alt={p.name}
                      className="profilecards-avatar"
                    />
                  </div>

                  <div className="profilecards-footer">
                    <svg
                      className="profilecards-wave"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 500 150"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0.00,49.98 C150.00,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                        style={{ fill: p.color }}
                      ></path>
                    </svg>

                    <div className="profilecards-footer-content">
                      <h3 className="profilecards-name">{p.name}</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <br />
        <br />
        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>100% Pass Guarantee and Additional Support</h3>
            <p>
              Worried about your exam performance? Enroll with us and get
              complete guidance for NIOS with a 100% pass assurance. We provide
              past-year question papers, conduct mock tests, and support you
              through assignment submissions—ensuring you’re fully prepared and
              confident for the exams.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            {/* <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form> */}
          </div>
        </div>
        {/* FAQ Section */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-2">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>
            <br />
            <br />
            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div
                        style={{ whiteSpace: "pre-line" }}
                        className="faq-answer"
                      >
                        {faq.answer}
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
